import PublicRoutes from './PublicRoutes';
import AjustesRoute from './AjustesRoute';
import Operaciones from '../views/Operaciones/Operaciones.vue';
import OperacionesMaritimas from '../views/Operaciones/OperacionesMaritimas.vue';
import OperacionesPackages from '../views/Operaciones/OperacionesPackages.vue';
import NuevaOperacion from '../views/NuevaOperacion/NuevaOperacion.vue';
import Polizas from '../views/Polizas/Polizas.vue';
import PolizasMaritimas from '../views/PolizasMaritimas/PolizasMaritimas.vue';
import PolizasPaqueteria from '../views/PolizasPaqueteria/PolizasPaqueteria.vue';
import PolizasContainer from '../views/PolizasContainer/PolizasContainer.vue';
import NumeracionPolizas from '../views/NumeracionPolizas/NumeracionPolizas.vue';
import SeguimientoWeb from '../views/SeguimientoWeb/SeguimientoWeb.vue';
import LogsEmails from '../views/LogsEmails/LogsEmails.vue';
import LogsPoliciesApi from '../views/LogsPoliciesApi/LogsPoliciesApi.vue';
import HomePanel from '../views/HomePanel/HomePanel.vue';
import EmisionDeCertificados from '../views/Certificados/EmisionDeCertificados.vue';
import NocLog from '../views/Noc/NocLogs.vue';
import { RouteRecordRaw } from 'vue-router';
import ListarCertificados from '../views/Certificados/ListarCertificados.vue';

const PrivateRoutes: Array<RouteRecordRaw> = [
  {
    path: '/panel',
    name: 'Panel',
    meta: { gate: true },
    children: [
      ...AjustesRoute,
      {
        path: 'home',
        name: 'HomePanel',
        component: HomePanel,
      },
      {
        path: 'operaciones',
        name: 'Operaciones',
        component: Operaciones,
      },
      {
        path: 'emision-de-certificados',
        name: 'Emision de Certificados',
        component: EmisionDeCertificados,
      },
      {
        path: 'certificados',
        name: 'Listar Certificados',
        component: ListarCertificados,
      },
      {
        path: 'operaciones-maritimas',
        name: 'Operaciones Maritimas',
        component: OperacionesMaritimas,
      },
      {
        path: 'operaciones-paqueteria',
        name: 'Operaciones de Paqueteria',
        component: OperacionesPackages,
      },
      {
        path: 'nueva-operacion',
        name: 'Nueva Operacion',
        component: NuevaOperacion,
      },
      {
        path: 'polizas-terrestres',
        name: 'Listar Polizas',
        component: Polizas,
      },
      {
        path: 'polizas-container',
        name: 'Listar Polizas Container',
        component: PolizasContainer,
      },
      {
        path: 'polizas-maritimas',
        name: 'Listar Polizas Maritimas',
        component: PolizasMaritimas,
      },
      {
        path: 'polizas-paqueteria',
        name: 'Listar Polizas de Paqueteria',
        component: PolizasPaqueteria,
      },
      {
        path: 'numeracion-polizas',
        name: 'Actualizar poliza Chubb',
        component: NumeracionPolizas,
      },
      {
        path: 'seguimiento-web',
        name: 'Seguimiento web',
        component: SeguimientoWeb,
      },
      {
        path: 'log-emails',
        name: 'Logs Emails',
        component: LogsEmails,
      },
      {
        path: 'log-policies-api',
        name: 'Logs Polizas API',
        component: LogsPoliciesApi,
      },
      {
        path: 'noc-log',
        name: 'Noc',
        component: NocLog,
      },
    ],
  },
];

export default PrivateRoutes;
